import {
  Box,
  Grid,
  GridItem,
  Text,
  Flex,
  Icon,
  Image,
  Button,
} from '@chakra-ui/react';
import { AiOutlineCalendar } from 'react-icons/ai';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { useMemo, useCallback } from 'react';
import PrettyRating from 'pretty-rating-react';
import { PengetahuanItem } from '../../../../types/pengetahuan';

type Props = {
  pengetahuanItem: PengetahuanItem;
};

const STAR_COLORS = {
  star: ['#FFDA6A', '#FFDA6A', '#434b4d'],
};

const PengetahuanHeader = ({ pengetahuanItem }: Props) => {
  const history = useHistory();
  const pengetahuanId = window.location.pathname.split('/', 4)[3];

  const handleLihatMateri = useCallback(() => {
    history.push(`/detail/pengetahuan/${pengetahuanId}?view=materi`);
  }, [history, pengetahuanId]);

  // kondisi button lihat materi
  const shouldShowButton = useMemo(() => {
    return (
      pengetahuanItem?.jenis_pengetahuan === 'asynchronized' ||
      (pengetahuanItem?.jenis_pengetahuan === 'synchronized' &&
        pengetahuanItem?.pengetahuan_materi_saya)
    );
  }, [pengetahuanItem?.jenis_pengetahuan, pengetahuanItem?.pengetahuan_materi_saya]);

  const isAsynchronized = pengetahuanItem?.jenis_pengetahuan === 'asynchronized';

  return (
    <Grid templateColumns="repeat(8, 1fr)" gap={{ base: 3, md: 5 }}>
      <GridItem colSpan={{ base: 8, md: 3 }}>
        <Image
          src={pengetahuanItem?.thumbnail}
          w="full"
          h="250px"
          rounded="xl"
          objectFit="cover"
          alt={`image-${pengetahuanItem?.title}`}
        />
      </GridItem>
      <GridItem colSpan={{ base: 8, md: 5 }}>
        <Box rounded="xl" w="full" h="full" p={4} bg="green.700">
          <Text fontSize="2xl" fontWeight="semibold" color="white" mb={3}>
            {pengetahuanItem?.title}
          </Text>
          <Text color="white" fontSize="sm" mb={3}>
            {pengetahuanItem?.nama_penyelenggara ?? ''}
          </Text>
          <Flex flexDirection={{ base: 'column', md: 'row' }}>
            <Flex mr={4}>
              <PrettyRating
                value={pengetahuanItem?.rata_rata_rating ?? 0}
                colors={STAR_COLORS.star}
              />
              <Text color="white" fontSize="sm" mx={2}>
                {pengetahuanItem?.rata_rata_rating}
              </Text>
              <Text color="white" fontSize="sm">
                ({pengetahuanItem?.review_count}{' '}
                <Text color="gray.200" as="span" fontSize="sm">
                  reviews
                </Text>
                )
              </Text>
            </Flex>
            <Flex mt={{ base: 2, md: 0 }}>
              <Icon as={AiOutlineCalendar} color="#FFDA6A" boxSize={5} mr={2} />
              <Text fontSize="sm" color="white">
                {isAsynchronized
                  ? pengetahuanItem?.created_at
                  : `${moment(pengetahuanItem?.jadwal_mulai).format(
                      'DD MMMM YYYY HH:mm'
                    )} - ${moment(pengetahuanItem?.jadwal_selesai).format(
                      'DD MMMM YYYY HH:mm'
                    )}`}
              </Text>
            </Flex>
          </Flex>
          {shouldShowButton && (
            <Button
              colorScheme="orange"
              onClick={handleLihatMateri}
              mt={6}
              fontSize="sm"
            >
              Lihat Materi
            </Button>
          )}
        </Box>
      </GridItem>
    </Grid>
  );
};

export default PengetahuanHeader;
